<section class="mt-2">
  <ngx-button-eksport-xls class="mr-2" [dane]="daneXls" [kolumny]="eksportXlsKolumny" nazwa="przychodyKoszty"></ngx-button-eksport-xls>
  <ngx-button-eksport-pdf class="mr-2" [dane]="danePdf" [kolumny]="eksportKolumny" [kolumnyStyle]="eksportPdfKolumnyStyle" nazwa="przychody_koszty" nazwaRaportu="{{ 'tytul.przychody-koszty' | translate }}" [zakresDat]="zakresDat"></ngx-button-eksport-pdf>
  <button nbButton size="small" (click)="wyswietlanieFiltrow = !wyswietlanieFiltrow">{{ wyswietlanieFiltrow ? ('akcja.ukryj-filtry' | translate) : ('akcja.pokaz-filtry' | translate) }}</button>
</section>

<!-- Widok desktopowy - tabela -->
<div class="desktop-view">
  <ngx-datatable 
    class="bootstrap" 
    [rows]="dane" 
    [summaryRow]="true"
    [summaryPosition]="'bottom'" 
    [headerHeight]="45" 
    [rowHeight]="45"
    [footerHeight]="50"
    [columnMode]="'flex'"
    [messages]="komunikatyTabeli"
    [limit]="15"
    (sort)="onSort($event)"
  >
    <ngx-datatable-column
      headerClass="font-weight-bold" 
      prop="liczbaPorzadkowa"
      name="{{ 'etykieta.lp' | translate }}"
      cellClass="text-right"
      [flexGrow]="1"
      [summaryFunc]=null
    >
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="okres"
      name="{{ 'etykieta.okres' | translate }}"
      cellClass="text-center"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
    >
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="przychody"
      name="{{ 'etykieta.przychody' | translate }}"
      cellClass="text-right"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
      [summaryFunc]="sumaKwota"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="koszty"
      name="{{ 'etykieta.koszty' | translate }}"
      cellClass="text-right"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
      [summaryFunc]="sumaKwota"
      *ngIf="wyswietlanieKosztow"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="saldo"
      name="{{ 'etykieta.saldo' | translate }}"
      cellClass="text-right"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl" 
      [summaryFunc]="sumaKwota"
      *ngIf="wyswietlanieKosztow"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>

<!-- Widok mobilny - kafelki -->
<div class="mobile-view">
  <!-- Filtr dla widoku mobilnego -->
  <div class="mobile-filter mb-3" *ngIf="wyswietlanieFiltrow">
    <input
      nbInput
      fullWidth
      type="search"
      placeholder="{{ 'etykieta.szukaj' | translate }}"
      (input)="updateFilterMobile($event)"
    />
  </div>

  <!-- Podsumowanie dla widoku mobilnego -->
  <nb-card accent="info" *ngIf="dane && dane.length > 0" class="mb-3">
    <nb-card-header>
      <span class="font-weight-bold">{{ 'etykieta.podsumowanie' | translate }}</span>
    </nb-card-header>
    <nb-card-body>
      <div class="row mb-2">
        <div class="col-6">
          <div class="stat-label">{{ 'etykieta.suma-przychodow' | translate }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="stat-value text-success">{{ sumaPrzychodow() | kwota }}</div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="wyswietlanieKosztow">
        <div class="col-6">
          <div class="stat-label">{{ 'etykieta.suma-kosztow' | translate }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="stat-value text-danger">{{ sumaKosztow() | kwota }}</div>
        </div>
      </div>
      <div class="row border-top pt-2" *ngIf="wyswietlanieKosztow">
        <div class="col-6">
          <div class="stat-label font-weight-bold">{{ 'etykieta.saldo-calkowite' | translate }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="stat-value font-weight-bold" [ngClass]="{'text-success': sumaSaldo() >= 0, 'text-danger': sumaSaldo() < 0}">
            {{ sumaSaldo() | kwota }}
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Kafelki z danymi -->
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let item of dane; let i = index">
      <nb-card>
        <nb-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">{{ item.okres }}</span>
            <span class="text-muted">#{{ item.liczbaPorzadkowa }}</span>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="row">
            <div class="col-6">
              <div class="stat-label">{{ 'etykieta.przychody' | translate }}</div>
              <div class="stat-value text-success">{{ item.przychody | kwota }}</div>
            </div>
            <div class="col-6" *ngIf="wyswietlanieKosztow">
              <div class="stat-label">{{ 'etykieta.koszty' | translate }}</div>
              <div class="stat-value text-danger">{{ item.koszty | kwota }}</div>
            </div>
          </div>
          <div class="row mt-3" *ngIf="wyswietlanieKosztow">
            <div class="col-12">
              <div class="stat-label">{{ 'etykieta.saldo' | translate }}</div>
              <div class="stat-value" [ngClass]="{'text-success': item.saldo >= 0, 'text-danger': item.saldo < 0}">
                {{ item.saldo | kwota }}
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>

<ng-template #hdrTpl let-column="column" let-sort="sortFn">
  <span class="font-weight-bold" (click)="sort()">{{ column.name }}</span>
  <span [hidden]="!wyswietlanieFiltrow">
    <br/>
    <input
      nbInput
      fieldSize="small"
      type="search"
      class="w-75"
      (input)="updateFilter($event, column.prop)"
    />
  </span>
</ng-template>